/** Слоты замера — синхрон с bot/bot/measurement_slots.py */

export const MEASUREMENT_INTERVALS = [
  { start: '10:00', end: '14:00', code: '10_14' },
  { start: '14:00', end: '18:00', code: '14_18' },
  { start: '18:00', end: '20:00', code: '18_20' },
] as const;

export type MeasurementIntervalCode = (typeof MEASUREMENT_INTERVALS)[number]['code'];

const WEEKDAY_SHORT = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'] as const;

export function toIsoDateLocal(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function parseIsoDateLocal(iso: string): Date {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, (m ?? 1) - 1, d ?? 1);
}

export function formatMeasurementDayLabel(d: Date): string {
  return `${WEEKDAY_SHORT[d.getDay() === 0 ? 6 : d.getDay() - 1] ?? ''} ${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function listMeasurementDays(daysAhead = 10): Array<{ iso: string; label: string }> {
  const out: Array<{ iso: string; label: string }> = [];
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  let offset = 0;
  while (out.length < daysAhead && offset < 21) {
    const d = new Date(start);
    d.setDate(start.getDate() + offset);
    offset += 1;
    if (d.getDay() === 0) continue;
    out.push({ iso: toIsoDateLocal(d), label: formatMeasurementDayLabel(d) });
  }
  return out;
}

export function humanizeMeasurementSlot(dayIso: string, code: MeasurementIntervalCode): string {
  const d = parseIsoDateLocal(dayIso);
  const dayPart = `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
  const slot = MEASUREMENT_INTERVALS.find((x) => x.code === code);
  if (!slot) return `${dayPart} (${code})`;
  return `${dayPart} с ${slot.start} до ${slot.end}`;
}

export function intervalButtonLabel(code: MeasurementIntervalCode): string {
  const slot = MEASUREMENT_INTERVALS.find((x) => x.code === code);
  return slot ? `${slot.start}–${slot.end}` : code;
}
